import { insertSuggestionChar } from "../../core/suggest/suggest";
export function startMentionSuggester(view, prefix, from, to) {
    if (from && to) {
        const tr = view.state.tr;
        tr.deleteRange(from, to);
        view.dispatch(tr);
    }
    view.dispatch(insertSuggestionChar(view.state, view.state.tr, prefix));
    view.focus();
}
